<template>
  <el-submenu v-if="menu.children && menu.children.length >= 1" :index="menu.id + ''"  >
    <template slot="title">
      <i :class="menu.icon"></i>
      <span slot="title">{{menu.name}}</span>
    </template>
    <MenuTree v-for="item in menu.children" :key="item.id" :menu="item"></MenuTree>
  </el-submenu>
  <el-menu-item v-else :index="menu.id + ''" @click="handleRoute(menu)">
    <i :class="menu.icon"></i>
    <span slot="title">{{menu.name}}</span>
  </el-menu-item>
</template>

<script>
  export default {
    name: 'MenuTree',
    props: {
      menu: {
        type: Object,
        required: true
      }
    },
    data(){
        return {
            menutree:[
                // {   children: null,
                //     code: "XXZX",
                //     createId: "1088612450133330858",
                //     createTime: 1588130947000,
                //     description: " ",
                //     display: false,
                //     icon: "el-icon-message-solid",
                //     id: "40",
                //     modifyId: null,
                //     modifyTime: null,
                //     name: "消息中心",
                //     parentId: "0",
                //     quickPath: null,
                //     state: 0,
                //     type: "menu",
                //     urlPath: "MessageCenter/AllNews"
                // },
                // {
                //     children: null,
                //     code: "WTFK",
                //     createId: "1088612450133330858",
                //     createTime: 1588130897000,
                //     description: " ",
                //     display: false,
                //     icon: "el-icon-question",
                //     id: "50",
                //     modifyId: null,
                //     modifyTime: null,
                //     name: "问题反馈",
                //     parentId: "0",
                //     quickPath: null,
                //     state: 0,
                //     type: "menu",
                //     urlPath: "ProblemFeedback/Problem"
                // },
                // {
                //     children:[
                //         {
                //             children: null,
                //             code: "WDDD",
                //             createId: "1088612450133330858",
                //             createTime: 1588140260000,
                //             description: " ",
                //             display: false,
                //             icon: " ",
                //             id: "1255377358416846849",
                //             modifyId: null,
                //             modifyTime: null,
                //             name: "我的订单",
                //             parentId: "60",
                //             quickPath: null,
                //             state: 0,
                //             type: "menu",
                //             urlPath: "Cost/Myorder"
                //         },
                //         {
                //             children: null,
                //             code: "FPGL",
                //             createId: "1088612450133330858",
                //             createTime: 1588140286000,
                //             description: " ",
                //             display: false,
                //             icon: " ",
                //             id: "1255377465572925441",
                //             modifyId: null,
                //             modifyTime: null,
                //             name: "发票管理",
                //             parentId: "60",
                //             quickPath: null,
                //             state: 0,
                //             type: "menu",
                //             urlPath: "Cost/invoice"
                //         }
                //     ],
                //     code: "FYZX",
                //     createId: "1088612450133330858",
                //     createTime: 1588130812000,
                //     description: " ",
                //     display: false,
                //     icon: "el-icon-s-goods",
                //     id: "60",
                //     modifyId: null,
                //     modifyTime: null,
                //     name: "费用中心",
                //     parentId: "0",
                //     quickPath: null,
                //     state: 0,
                //     type: "menu",
                //     urlPath: ""
                // },
                // {
                //     children:[
                //         {
                //             children: null,
                //             code: "ZHLB",
                //             createId: "1088612450133330858",
                //             createTime: 1588140130000,
                //             description: " ",
                //             display: false,
                //             icon: " ",
                //             id: "1255376814222680066",
                //             modifyId: null,
                //             modifyTime: null,
                //             name: "账号列表",
                //             parentId: "70",
                //             quickPath: null,
                //             state: 0,
                //             type: "menu",
                //             urlPath: "Differential/AccountNumber"
                //         },
                //         {
                //             children: null,
                //             code: "FZGL",
                //             createId: "1088612450133330858",
                //             createTime: 1588140157000,
                //             description: " ",
                //             display: false,
                //             icon: " ",
                //             id: "1255376927221424129",
                //             modifyId: null,
                //             modifyTime: null,
                //             name: "分组管理",
                //             parentId: "70",
                //             quickPath: null,
                //             state: 0,
                //             type: "menu",
                //             urlPath: "Differential/Grouping"
                //         }
                //     ],
                //     code: "CFZH",
                //     createId: "1088612450133330858",
                //     createTime: 1588130668000,
                //     description: " ",
                //     display: false,
                //     icon: "el-icon-s-management",
                //     id: "70",
                //     modifyId: null,
                //     modifyTime: null,
                //     name: "差分帐号",
                //     parentId: "0",
                //     quickPath: null,
                //     state: 0,
                //     type: "menu",
                //     urlPath: ""
                // },
                // {
                //     children: null,
                //     code: "YHZX",
                //     createId: "1088612450133330858",
                //     createTime: 1588065412000,
                //     description: "  ",
                //     display: false,
                //     icon: "el-icon-user-solid",
                //     id: "80",
                //     modifyId: null,
                //     modifyTime: null,
                //     name: "用户中心",
                //     parentId: "0",
                //     quickPath: null,
                //     state: 0,
                //     type: "menu",
                //     urlPath: ""
                // }
            ]
        }
    },
    methods: {
      handleRoute (menu) {
        //console.log(menu,'------------------')
        // 通过菜单URL跳转至指定路由
        this.$router.push(menu.urlPath)
      }
    }
  }
</script>
<style lang="less" scoped >

</style>



// WEBPACK FOOTER //
// src/components/menu/MenuTree.vue